export default __webpack_public_path__ + "static/media/F3000.5a992470.jpg";